// extracted by mini-css-extract-plugin
export var compactFilters = "_do-4";
export var detailImage = "_do-1";
export var dropdownContainer = "_do-2";
export var imageContainer = "_do-0";
export var selectedCard = "_do-3";